import { put, putResolve } from 'typed-redux-saga';

import * as global from '@/model/global/actions';
import { getCyrillicErrorMessage, getErrorCode } from '@/utils/api';
import { ActionWithoutPayload, ActionWithPayload } from '@/utils/redux';

import { storeLoading } from './actions';

const callStack: { messageId?: string }[] = [];
const previousMessage = (): string | undefined =>
  callStack.length - 1 > 0 ? callStack[callStack.length - 1].messageId : undefined;

export const withGlobalLock = <P, T extends ActionWithPayload<P> | ActionWithoutPayload>(
  worker: (action: T) => Generator<any, any, any>,
  messageId: string | undefined = previousMessage(),
): ((action: T) => Generator<unknown, void, T>) =>
  function* runner(action: T): Generator<unknown, void, T> {
    callStack.push({ messageId });
    yield* putResolve(storeLoading({ loading: true, messageId }).pure);
    try {
      return yield* worker(action);
    } finally {
      callStack.pop();
      if (callStack.length === 0) {
        yield put(storeLoading({ loading: false }).pure);
      }
    }
  };

export const onResponseErrorMessage = (namespace: string, defaultMessageId: string, ignoreCodes: string[] = []) =>
  function* onError(error: any): Generator {
    const code = getErrorCode(error);
    const message = code && !ignoreCodes.includes(code) ? getCyrillicErrorMessage(error) : undefined;
    yield* put(
      global.addNotification({
        type: namespace,
        severity: 'error',
        ...(message ? { message } : { messageId: defaultMessageId }),
      }).pure,
    );
  };
